export let globals = {
	isMuted: false,
	worldScale: 0
};